<template>
  <div class="countccer">
    <ul>
      <li>
        <img src="../../assets/shending.png" alt="已审定" />
        <span>开机</span>
        <span>({{ ccerCountData.yishending }}/{{ ccerCountData.allc }})</span>
      </li>
      <li>
        <img src="../../assets/beian.png" alt="已备案" />
        <span>关机</span>
        <span>({{ ccerCountData.yibeian }}/{{ ccerCountData.allc }})</span>
      </li>
      <li>
        <img src="../../assets/jiance.png" alt="减排量检测" />
        <span>报警</span>
        <span
          >({{ ccerCountData.jianpailiangjiance }}/{{
            ccerCountData.allc
          }})</span
        >
      </li>
      <li>
        <img src="../../assets/hezheng.png" alt="已核证" />
        <span>待机</span>
        <span>({{ ccerCountData.yihezhneg }}/{{ ccerCountData.allc }})</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "countccer",
  props: {
    ccerCountData: {
      type: Object,
      default: null
    }
  },
  watch: {
    ccerCountData (newValue) {
      if (newValue != null) {
        this.ccerCountData = newValue
      }
    }
  },
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  }
}
</script>

<style scoped>
.countccer ul {
  display: flex;
  justify-content: center;
  align-items: center;
}
.countccer li {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: space-around;
  justify-content: flex-end;
  align-items: center;
}
.countccer li img {
  max-width: 100px;
  padding: 15px 0px;
}
.countccer li span {
  font-size: 18px;
  font-family: "黑体";
  line-height: 1.6em;
}
</style>



// WEBPACK FOOTER //
// src/components/right/countccer.vue